import {
  ADD_PRODUCT_TO_CART,
  SUB_PRODUCT_OF_CART,
  LOAD_CART_PAYTYPE_LIST_DATA,
  SET_DELETE_POPUP,
  UPDATE_DELETE_ITEM,
  REMOVE_PRODUCT_OF_CART
} from '@store/officialTopup/cart';
import {
  UPDATE_LOADING,
  LOAD_PAYTYPE_LIST_DATA,
  UPDATE_SHOW_DETAIL_POPUP_DATA,
  CLOSE_DETAIL_POPUP,
  OPEN_GLOBAL_TIPS
} from '@store/officialTopup';
import { mapState, mapGetters } from 'vuex';
import {
  clickButton,
  locationType,
  showPopup,
  popupType
} from '@plugins/biPoint/_configWebstoreV3';
import {
  storeProductParam,
  storeCpProductId,
  getCurLocation
} from '@store/officialTopup/storager';
import globalConfig from '@utiles/officialStore/globalConfig';
import { b64EncodeUnicode } from '@utiles/officialStore';

export default {
  props: {
    showDetailPopupBtn: {
      default: false
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      cartList: state => state.cart.cartList,
      cartQuantityLimit: state => state.cart.cartQuantityLimit,
      deleteItem: state => state.cart.deleteItem,
      deleteIndex: state => state.cart.deleteIndex,
      paytype: state => state.paytype,
      curLocation: state => state.curLocation,
      curTax: state => state.curTax,
      gameId: state => state.gameId,
      roleName: state => state.roleName,
      uid: state => state.login.uid,
      lang: state => state.lang
    }),
    ...mapGetters([
      'cartTotalQuantity',
      'cartTotalPrice',
      'cartDiscountTransMount',
      'cartProductType',
      'cartProductNum'
    ]),
    isShowTax() {
      return +this.curTax > 0 && this.curLocation === 'US';
    },
    realPrice() {
      const showPrice =
        this.cartTotalPrice + (this.isShowTax ? +this.curTax : 0);
      if (this.currency === 'VND') {
        return showPrice;
      }
      return showPrice.toFixed(2);
    }
  },
  methods: {
    handleSingleProductLimit(item) {
      this.$store.commit(
        OPEN_GLOBAL_TIPS,
        `${this.letter.limit_buy_product.replace('${n}', item.LIMIT)}`
      );
    },
    handleTotalProductLimit() {
      this.$store.commit(
        OPEN_GLOBAL_TIPS,
        `${this.letter.limit_order.replace('${n}', this.cartQuantityLimit)}`
      );
    },
    handleProductPriceError() {
      this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.fail_and_later);
    },
    addToCart(item) {
      window.webstorev3DataLayer.push({
        eventName: 'select_product',
        eventType: 'add_to_cart',
        eventReason: 'click_select',
        eventValue: {
          product_type: item.PRODUCT_TYPE || '',
          cp_product_id: item.CP_PRODUCT_ID || '',
          product_id: item.PRODUCT_ID || '',
          product_num: 1,
          product_currency: item.CURRENCY || '',
          product_money: item.GAME_AMOUNT || ''
        }
      });
      const errorHandle = {
        singleProductLimit: 'handleSingleProductLimit',
        totalProductLimit: 'handleTotalProductLimit',
        productPriceError: 'handleProductPriceError'
      };

      if (+item.quantity >= +item.LIMIT) {
        this[errorHandle.singleProductLimit](item);
        return;
      }
      if (this.cartTotalQuantity + 1 > this.cartQuantityLimit) {
        this[errorHandle.totalProductLimit]();
        return;
      }
      if (
        !item.amountLevel ||
        !item.amountLevel?.TRANS_AMOUNT ||
        !item.amountLevel?.SHOW_CURRENCY
      ) {
        this[errorHandle.productPriceError]();
        return;
      }
      this.doAddToCart(item);
    },
    doAddToCart(item) {
      this.$store.commit(ADD_PRODUCT_TO_CART, item);
      this.$store.commit(CLOSE_DETAIL_POPUP);
    },
    handleProductDetail(item) {
      this.$store.commit(UPDATE_SHOW_DETAIL_POPUP_DATA, {
        item,
        showBtn: this.showDetailPopupBtn,
        show: true
      });
    },
    doSubProduct(item, index) {
      if (+item.quantity === 1) {
        this.$store.commit(SET_DELETE_POPUP, true);
        this.$store.commit(UPDATE_DELETE_ITEM, item);
        showPopup(popupType.removeCartProductPopup);
        return;
      }
      this.subProduct(item);
    },
    cancelSubProduct() {
      this.$store.commit(SET_DELETE_POPUP, false);
    },
    subProduct(item) {
      this.$store.commit(SUB_PRODUCT_OF_CART, item);
    },
    doRemoveProduct(item, index) {
      this.$store.commit(SET_DELETE_POPUP, true);
      this.$store.commit(UPDATE_DELETE_ITEM, item);
      showPopup(popupType.removeCartProductPopup);
    },
    removeProduct(item) {
      // 删除数组中这个index的元素
      this.$store.commit(REMOVE_PRODUCT_OF_CART, item);
      window.webstorev3DataLayer.push({
        eventName: 'remove_cart',
        eventType: 'add_to_cart',
        eventValue: {
          product_type: item.PRODUCT_TYPE || '',
          cp_product_id: item.CP_PRODUCT_ID || '',
          product_id: item.PRODUCT_ID || '',
          product_num: 1,
          product_currency: item.CURRENCY || '',
          product_money: item.GAME_AMOUNT || ''
        }
      });
    },
    getCartListParam() {
      return this.cartList.map(item => {
        return {
          productId: item.PRODUCT_ID,
          cpProductId: item.CP_PRODUCT_ID,
          remark: item.REMARK || '',
          amount: item.amountLevel.TRANS_AMOUNT || '',
          quantity: item.quantity,
          productDesc: item?.CP_PRODUCT_DESC || item?.PRODUCT_DESC || '',
          cpProductExt: item.CP_PRODUCT_EXT || {}
        };
      });
    },
    sendCheckCartData() {
      window.webstorev3DataLayer.push({
        eventName: 'check_cart',
        eventType: 'add_to_cart',
        eventReason: 'click_select',
        eventValue: {
          product_type: this.cartProductType,
          cp_product_id: '',
          product_id: '',
          product_num: this.cartList.length,
          product_list: b64EncodeUnicode(
            JSON.stringify(this.getCartListParam())
          ),
          product_currency: this.currency,
          product_money: this.cartTotalPrice
        }
      });
    },
    loadCartPayTypeListData() {
      if (!this.cartList.length) return;
      if (this.cartProductNum === 1) {
        // 购物车只有1个商品走单个商品支付渠道获取
        const item = this.cartList[0];
        storeProductParam({
          gameId: this.gameId,
          serverId: this.$store.state.pcServerId,
          roleId: this.$store.state.roleId,
          roleName: this.roleName,
          packageName: globalConfig.getHrefParam('packageName'),
          userId: this.uid,
          productId: item?.PRODUCT_ID || '',
          cpProductId: item?.CP_PRODUCT_ID || '',
          devicePlate: globalConfig.getHrefParam('devicePlate'),
          remark: item?.REMARK || '',
          location: getCurLocation() || '',
          appLanguage: this.lang,
          language: this.lang,
          productType: this.cartProductType
        });
        storeCpProductId(item?.CP_PRODUCT_ID || '');
        this.$store.commit(UPDATE_LOADING, true);
        this.$store.dispatch(LOAD_PAYTYPE_LIST_DATA);
      } else {
        // 多个商品走购物车支付渠道获取
        this.sendCheckCartData();
        storeProductParam({
          gameId: this.gameId,
          serverId: this.$store.state.pcServerId,
          roleId: this.$store.state.roleId,
          roleName: this.roleName,
          packageName: globalConfig.getHrefParam('packageName'),
          userId: this.uid,
          devicePlate: globalConfig.getHrefParam('devicePlate'),
          location: getCurLocation() || '',
          appLanguage: this.lang,
          language: this.lang,
          productType: this.cartProductType
        });
        this.$store.commit(UPDATE_LOADING, true);
        this.$store.dispatch(LOAD_CART_PAYTYPE_LIST_DATA);
        this.$emit('closeSelecter');
      }
    }
  }
};
